import { useTranslation } from 'react-i18next';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { toast } from '@valwin/facto/components';

import { deleteStoreKey } from '../api';
import { logout } from '../auth';
import { facebookQueries } from './queries';

export function useDisconnectFacebook(pharmacyId: string) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await deleteStoreKey(pharmacyId);
      // logout is best-effort: forces the FB popup on next reconnection so the user can reselect pages.
      // If it fails, the backend is already disconnected — silent fail is acceptable.
      await logout().catch(() => {});
    },
    onSuccess: () => {
      queryClient.setQueryData(facebookQueries.pages(pharmacyId).queryKey, []);
      toast.success(t('toast accountDisconnected'), {
        description: t('toast facebookAccountDisconnected description'),
      });
    },
    onError: () => {
      toast.error(t('toast error'), {
        description: t('toast facebookAccountDisconnecting error description'),
      });
    },
  });
}
